export class ValidationError {
	propertyName: string = "";
	errorMessage: string = "";
}
export class UpdateResponse<T> {
	item: T | null = null;
	success: boolean = false;
	validationErrors: ValidationError[] = [];
}
